import {
  TRANSLOCO_CONFIG,
  TRANSLOCO_LOADER,
  translocoConfig,
  TranslocoLoader,
  TranslocoModule,
} from '@ngneat/transloco';
import { Injectable, NgModule } from '@angular/core';
import { environment } from '@env/environment';
import { SYSTEM_LANGUAGES } from '../../assets/i18n';
import { of } from 'rxjs';
import { LocalizePipe } from '@app/shared/pipes/localize.pipe';

const langs = Object.keys(SYSTEM_LANGUAGES);

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  getTranslation(lang: string) {
    if (!SYSTEM_LANGUAGES[lang]) SYSTEM_LANGUAGES[lang] = SYSTEM_LANGUAGES.RU;
    return of(SYSTEM_LANGUAGES[lang]);
  }
}

@NgModule({
  exports: [TranslocoModule, LocalizePipe],
  declarations: [LocalizePipe],
  providers: [
    {
      provide: TRANSLOCO_CONFIG,
      useValue: translocoConfig({
        availableLangs: langs,
        defaultLang: 'ru',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: environment.production,
      }),
    },
    { provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader },
  ],
})
export class TranslocoRootModule {}
